import { render } from "./fondocambiante.vue?vue&type=template&id=c8471466&scoped=true"
import script from "./fondocambiante.vue?vue&type=script&lang=js"
export * from "./fondocambiante.vue?vue&type=script&lang=js"

import "./fondocambiante.vue?vue&type=style&index=0&id=c8471466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8471466"]])

export default __exports__